const businessVerification = {
  list: {
    title: "Verification Requests List",
    noDataPlaceholder: "No requests yet",
    searchPlaceholder: "Search by company name",
    companyName: "Company Name",
    country: "Country",
    businessType: "Business Type",
    verificationMethod: "Verification Method",
    status: "Status",
    requestDate: "Request Date",
    filters: {
      businessType: "Business Type",
      country: "Country",
      searchCountry: "Search by country name",
      verificationMethod: "Verification Method",
      status: "Status",
      searchStatus: "Search by status name"
    }
  },
  verificationMethods: {
    onlinePayment: "Online Payment",
    bankTransfer: "Bank Transfer",
    offPlatform: "Off platform verification"
  },
  requestStatus: {
    inProgress: "In Progress",
    accepted: "Accepted",
    rejected: "Rejected"
  },
  inprogressRequestStatus: {
    awaitRequiredDocuments: "Awaiting Required Docs",
    pendingDocumentsUpload: "Pending Docs Upload",
    documentsUploaded: "Docs Uploaded",
    pendingPayment: "Pending Payment",
    documentNeedsUpdates: "Docs Need Updates",
    pendingFinalApproval: "Pending Final Approval",
    accepted: "Accepted",
    rejected: "Rejected"
  },
  requestDetails: {
    title: "Request Details",
    noData: "No request found",
    verificationMethod: "Verification Method",
    requestStatus: "Request Status",
    companySection: {
      companyInfo: "Company Info",
      companyName: "Company Name",
      businessType: "Business Type",
      country: "Country"
    },
    offplatformRequest: {
      requiredDocuments: "Required Documents",
      requiredDocsEdit: "The documents need these updates:",
      addDocuments: {
        docsHint:
          "You can upload the documents either by providing the name, uploading a file, or by doing both.",
        typeDocsName: "Type The Required Documents name",
        docName: "Document Name",
        docNamePlaceholder: "Enter the name",
        uploadDocs: "Upload The Requirement Documents",
        maxFiles: "(Max 15 Files)",
        docsMaxNumber: "The max allowed number of documents is 15"
      },
      waitUploadDocs: {
        docsRequestedTitle: "Documents Requested by The Support Team",
        docsRequestedMsg:
          "The support team has sent the required documents to the user. We are now waiting for the user to upload them."
      },
      reviewDocs: {
        uploadedDocs: "Uploaded Documents",
        representativeInfo: "Company Representative Info",
        representativeName: "Representative Name",
        representativeEmail: "Email Address",
        representativeMobile: "Mobile Number",
        representativeJobTitle: "Job Title",
        representativeId: "Representative ID"
      },
      transactions: {
        transactionsInfo: "Transactions",
        id: "ID",
        accountName: "Account Name",
        date: "Date",
        paymentMethod: "Payment Method",
        amount: "Amount",
        country: "Billing Country"
      }
    },
    onlinePayment: {
      transactionsInfo: "Transactions Info",
      id: "ID",
      accountName: "Account Name",
      date: "Date",
      paymentMethod: "Payment Method",
      amount: "Amount",
      country: "Billing Country"
    },
    bankTransfer: {
      bankTransferTranscript: "The bank transfer transcript"
    }
  },
  actions: {
    approveDocs: {
      btnLabel: "Approve Docs",
      title: `Approve ":companyName" Docuemnts`,
      confirmMsg: "Are you sure you want to approve these documents?"
    },
    requestUpdates: {
      btnLabel: "Request Updates",
      confirmMsg: `Please clarify the updates you need in ":companyName" documents`,
      updates: "Updates",
      updatesPlaceholder: "Type Here..."
    },
    approveRequest: {
      btnLabel: "Accept",
      title: `Accept ":companyName" Verification Request`,
      confirmMsg: "Are you sure you want to accept this request?"
    },
    rejectRequest: {
      btnLabel: "Reject",
      title: `Reject ":companyName" Verification Request`,
      confirmMsg: "Are you sure you want to reject this request?",
      rejectionReason: "Rejection Reason",
      typeHere: "Type Here"
    }
  }
};

export default businessVerification;
